var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-ships" },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Schepen", icon: "fa-ship" } },
        [
          _c(
            "ui-button",
            {
              attrs: {
                color: "positive",
                icon: "magicon-plus",
                route: "ship-add",
              },
            },
            [_vm._v("Schip toevoegen")]
          ),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "ui-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            clickable: "",
            placeholder: _vm.ships && !_vm.ships.items.length,
            total: _vm.$safe("ships.totalCount"),
            visible: _vm.paging.limit,
          },
          on: { page: _vm.switchPage },
        },
        [
          _c(
            "ui-table-header",
            [
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "name" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Naam")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "growerId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Kweker")]
              ),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.$safe("ships.items"), function (ship) {
            return _c("ui-tr", { key: ship.id, attrs: { click: "edit" } }, [
              _c("td", [_vm._v(_vm._s(ship.name))]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("empty")(_vm.$safe(ship, "grower.name")))),
              ]),
              _c(
                "td",
                {
                  staticClass: "actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Wijzigen",
                        expression: "'Wijzigen'",
                      },
                    ],
                    attrs: {
                      icon: "magicon-edit",
                      action: "edit",
                      to: { name: "ship-edit", params: { id: ship.id } },
                    },
                  }),
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Verwijderen",
                        expression: "'Verwijderen'",
                      },
                    ],
                    attrs: { icon: "magicon-trash" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteShip(ship.id)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }